export interface ToolbarButton {
  key: string;
  link: string;
  status?: string;
}

// Configuración de botones del toolbar
export const toolbarButtons: ToolbarButton[] = [
  { key: 'all', link: '#' },
  { key: 'pending_review', link: '#', status: 'PENDING_REVIEW' },
  { key: 'approved', link: '#', status: 'APPROVED' },
  { key: 'rejected', link: '#', status: 'REJECTED' },
];

